import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let InputComp;

class Input extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: InputComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/zcat-components/input-comp" */
      "../../../components/javascript/zcat-components/input-comp").then(function(res) {
        InputComp = res.InputComp;
      })
    );

    
;
  }
}

export { Input };
